import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import { DpaGate } from "@/components/DpaGate";
import Landing from "@/pages/Landing";
import Subscribe from "@/pages/Subscribe";
import Legal from "@/pages/Legal";
import Admin from "@/pages/Admin";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Pipeline from "@/pages/Pipeline";
import CalendarPage from "@/pages/CalendarPage";
import Templates from "@/pages/Templates";
import Settings from "@/pages/Settings";
import BookingSettings from "@/pages/BookingSettings";
import PublicBooking from "@/pages/PublicBooking";
import PublicAgentPrivacy from "@/pages/PublicAgentPrivacy";
import ManageAppointment from "@/pages/ManageAppointment";
import Assistant from "@/pages/Assistant";
import Commissions from "@/pages/Commissions";
import PublicDocuments from "@/pages/PublicDocuments";
import PublicPrivacy from "@/pages/PublicPrivacy";

const Loading = () => (
  <div className="min-h-screen grid place-items-center text-slate-400" data-testid="auth-loading">
    Caricamento…
  </div>
);

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (["none", "blocked"].includes(user.access)) return <Navigate to="/abbonamento" replace />;
  return <Layout><DpaGate />{children}</Layout>;
};

const Bare = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const AppRouter = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  const P = (el) => <Protected>{el}</Protected>;
  return (
    <Routes>
      <Route path="/login" element={<Landing />} />
      <Route path="/abbonamento" element={<Bare><Subscribe /></Bare>} />
      <Route path="/payment/success" element={<Bare><PaymentSuccess /></Bare>} />
      <Route path="/termini" element={<Legal />} />
      <Route path="/dpa" element={<Legal />} />
      <Route path="/privacy-policy" element={<Legal />} />
      <Route path="/cookie-policy" element={<Legal />} />
      <Route path="/admin" element={P(<Admin />)} />
      <Route path="/prenota/:slug" element={<PublicBooking />} />
      <Route path="/prenota/:slug/privacy" element={<PublicAgentPrivacy />} />
      <Route path="/appuntamento/:token" element={<ManageAppointment />} />
      <Route path="/prenotazioni" element={P(<BookingSettings />)} />
      <Route path="/assistente" element={P(<Assistant />)} />
      <Route path="/provvigioni" element={P(<Commissions />)} />
      <Route path="/documenti/:token" element={<PublicDocuments />} />
      <Route path="/privacy/:token" element={<PublicPrivacy />} />
      <Route path="/" element={P(<Dashboard />)} />
      <Route path="/dashboard" element={P(<Dashboard />)} />
      <Route path="/clienti" element={P(<Clients />)} />
      <Route path="/clienti/:id" element={P(<ClientDetail />)} />
      <Route path="/pratiche" element={P(<Pipeline />)} />
      <Route path="/calendario" element={P(<CalendarPage />)} />
      <Route path="/modelli" element={P(<Templates />)} />
      <Route path="/impostazioni" element={P(<Settings />)} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}
